<template>
    <div class="flex h-full w-full">
        <card :to="props.to" class="w-full">
            <aspect-ratio-box :ratio="400/100" class="flex-grow-1">
                <aspect-ratio-box :ratio="5" :style="{backgroundColor: props.user?.color ?? $config.public.colors.gray_300}" class="absolute top-0 w-full opacity-75"/>

                <div class="z-1 flex items-center justify-center mb-16">
                    <avatar :model="props.user" :size="$breakpoint.smAndUp ? 40 : 32" :color="props.user?.avatar_thumbnail ? 'transparent' : 'gray-300'" class="shadow" round/>
                </div>
            </aspect-ratio-box>

            <div class="flex flex-column items-center justify-center py-8">
                <p class="text-center w-full text-2xs sm:text-xs leading-normal truncate mb-0" :style="{color: props.user?.color ?? $config.public.colors.gray_300}">
                    {{ props.title ?? props.user?.display_name }}</p>
            </div>
        </card>
    </div>
</template>

<script setup lang="ts">
import type {UserPreview} from "@spoferan/spoferan-ts-core";

const props = defineProps<{
	user?: UserPreview,
	to?: String,
	title?: String
}>();

</script>